import CommentEditor from '@app/components/CommentEditor'
import FavoriteToggle from '@app/components/FavoriteToggle'
import { IFeedItem } from '@app/models/FeedItem'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import CommentsList from '../containers/CommentsListContainer'

interface IFeedItemFooterProps {
  item: IFeedItem
  loadComments: (feedItemId: string) => void
  onLayoutChanged?: () => void
  toggleFeedItemFavorite: (
    feedItemId: string,
    userId: string,
    favorite: boolean,
  ) => void
  toggleShowComments: (feedItemId: string, show: boolean) => void
}

type FeedItemFooterProps = IFeedItemFooterProps

export default class FeedItemFooter extends React.PureComponent<
  FeedItemFooterProps
> {
  constructor(props: IFeedItemFooterProps) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='feed-item-footer'>
        <div className='text-right'>
          <div>
            <FavoriteToggle
              className='ml-2 text-primary'
              hasStarred={this.props.item.hasStarred}
              onToggleFavorite={this._toggleFeedItemFavorite}
              showCount
            />
            <a
              className='ml-2 text-primary'
              onClick={this._toggleComments}
              title='Comments'
            >
              <FontAwesomeIcon icon={['far', 'comment-alt']} fixedWidth />
              {this.props.item.totalComments > 0
                ? this.props.item.totalComments
                : null}
            </a>
          </div>
        </div>
        {this.props.item.showComments && this._renderComments()}
      </div>
    )
  }

  private _renderComments() {
    if (!this.props.item.comments) {
      return null
    }

    return (
      <div>
        {this._renderLoadMoreComments()}
        <CommentsList items={this.props.item.comments} />
        <CommentEditor
          contextId={this.props.item.id}
          defaultPublic={this.props.item.isPublic}
          onResize={this.props.onLayoutChanged}
        />
      </div>
    )
  }

  private _renderLoadMoreComments() {
    if (this.props.item.totalComments === 0) {
      return null
    }

    let loadedCommentsCount = 0
    if (this.props.item.comments) {
      loadedCommentsCount = this.props.item.comments.size
    }

    const additionalCommentsCount =
      this.props.item.totalComments - loadedCommentsCount

    if (additionalCommentsCount <= 0) {
      return null
    }

    return (
      <a className='my-2' onClick={this._loadComments}>
        View {additionalCommentsCount} more{' '}
        {additionalCommentsCount === 1 ? 'comment' : 'comments'}
      </a>
    )
  }

  private _loadComments() {
    this.props.loadComments(this.props.item.id)
  }

  private _toggleComments() {
    this.props.toggleShowComments(
      this.props.item.id,
      !this.props.item.showComments,
    )
  }

  private _toggleFeedItemFavorite(userId: string, isFavorite: boolean) {
    this.props.toggleFeedItemFavorite(this.props.item.id, userId, isFavorite)
  }
}
